import Vue from 'vue';
import store from '../store/index';
import { i18n } from '@/i18n';

function tips(vnode: any, binding: any) {
  Vue.prototype.$message({
    message: i18n('Manual is not permitted, please Scan the Label!'),
    type: 'warning',
    duration: 2000,
  });
  const express = binding.expression;
  const format = express.split('.');
  switch (format.length) {
    case 1:
      vnode.context[format[0]] = '';
      break;
    case 2:
      vnode.context[format[0]][format[1]] = '';
      break;
  }
}
function handleInput(interval = 200, vnode: any, binding: any) {
  let time: any = null;
  return {
    inputHandler: () => {
      time = +new Date();
    },
    enterHandler: (e: any) => {
      if (!time || e.keyCode !== 13) return;
      const now = +new Date();
      if (now - time > interval) {
        e.preventDefault();
        e.stopPropagation();
        tips(vnode, binding);
        time = null;
        console.log('is hand');
      } else {
        console.log('is scan');
      }
    },
  };
}
function blockPasteAndDrop(input: HTMLInputElement, message?: string) {
  const warningMessage =
    message || i18n('Manual is not permitted, please Scan the Label!');
  input.addEventListener('paste', (e: Event) => {
    Vue.prototype.$message({
      message: warningMessage,
      type: 'warning',
      duration: 2000,
    });
    e.preventDefault(); // 禁用粘贴功能
  });
  input.addEventListener('drop', (e: Event) => {
    Vue.prototype.$message({
      message: warningMessage,
      type: 'warning',
      duration: 2000,
    });
    e.preventDefault(); // 禁用拖动录入功能
  });
}
const onlyScanInput = {
  bind: function (el: any, binding: any, vnode: any) {
    const input = el.querySelector('input');
    if (!input) return;
    const value = binding.value || {};
    // pasteOnly 模式：仅拦截 paste/drop，不做键盘输入速度判断
    // （键盘输入与扫描均可用，仅禁止粘贴/拖拽录入）
    if (value.pasteOnly) {
      blockPasteAndDrop(input, value.pasteErrorMessage);
      return;
    }
    // 默认模式：完全保持既有行为（block paste + 速度判断，受 interval 权限门控）
    let interval = value.interval;
    const isSubmit = value.isSubmit;
    if (typeof interval === 'string') {
      interval = store.state.permission.userPermission.includes(interval)
        ? false
        : 200;
    }
    if (!interval) return;
    const obj = handleInput(interval, vnode, value);
    blockPasteAndDrop(input);
    input.addEventListener('input', obj.inputHandler);
    if (isSubmit) {
      input.addEventListener('keypress', obj.enterHandler, false);
    } else {
      input.addEventListener('keyup', obj.enterHandler, false);
    }
  },
};
export { onlyScanInput };
